import { render, staticRenderFns } from "./CustomerEmailChange.vue?vue&type=template&id=88853ade"
import script from "./CustomerEmailChange.vue?vue&type=script&lang=js"
export * from "./CustomerEmailChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports